export default {
  BUVoucherListRealExpense: 'https://mimosahelp.misa.vn/kb/lap-bang-ke-chung-tu-thanh-toan-thuc-chi/', // Bảng kê thực chi
  BUVoucherListOther: 'https://mimosahelp.misa.vn/kb/lap-bang-ke-chung-tu-thanh-toan-tam-ung-cho-cac-hoa-don-mua-hang/', // Bảng kê khác
  CAReceipt: 'https://mimosahelp.misa.vn/kb/ke-toan-tien-mat/', // thu tiền mặt
  CAReceiptWithDraw: 'https://mimosahelp.misa.vn/kb/rut-tien-gui-nhkb-nhap-quy-tien-mat/', // thu NHKB
  CAReceiptPlanWithDraw: 'https://mimosahelp.misa.vn/kb/nhan-cac-khoan-kinh-phi-bang-tien-mat/', // thu rút dự toán nhập quỹ
  CAPaymentDeposit: 'https://mimosahelp.misa.vn/kb/chi-tien-mat-nop-vao-tai-khoan-ngan-hang/', // Chi nộp NHKB
  CAPayment: 'https://mimosahelp.misa.vn/kb/ke-toan-tien-mat/', // Chi tiền mặt
  BADeposit: 'https://mimosahelp.misa.vn/kb/ke-toan-tien-gui/', // Thu tiền gửi
  BAWithDraw: 'https://mimosahelp.misa.vn/kb/ke-toan-tien-gui/', // Chi tiền gửi
  BABankTransfer: 'https://mimosahelp.misa.vn/kb/chuyen-tien-noi-bo/', // Chuyển tiền nội bộ
  FAVoucherIncrement: 'https://mimosahelp.misa.vn/kb/ghi-tang-tscd-co-su-dung-phan-mem-qlts/', // Ghi tăng QLTS
  FAVoucherDecrement: 'https://mimosahelp.misa.vn/kb/ghi-giam-tscd-co-su-dung-phan-mem-qlts/', // Ghi giảm QLTS
  FAVoucherAdjustment: 'https://mimosahelp.misa.vn/kb/danh-gia-lai-tscd-co-su-dung-phan-mem-qlts/', // Đánh giá lại QLTS
  FAVoucherDepreciate: 'https://mimosahelp.misa.vn/kb/trich-khau-hao-tscd-co-su-dung-phan-mem-qlts/', // Trích khấu hao QLTS
  FAVoucherDepreciation: 'https://mimosahelp.misa.vn/kb/tinh-hao-mon-tscd-co-su-dung-phan-mem-qlts/', // Tính hao mòn QLTS
  PUPaymentDetail: 'https://mimosahelp.misa.vn/kb/mua-vat-tu-hang-hoa-nhap-kho/', // Phiếu chi, chi tiền gửi, CKKB mua VTHH
  PUInvoiceDetail: ' https://mimosahelp.misa.vn/kb/nhap-mua-chua-thanh-toan/', // Nhập kho mua chưa thanh toán
  INInward: 'https://mimosahelp.misa.vn/kb/nhap-khac/', // Nhập kho khác
  INOutward: 'https://mimosahelp.misa.vn/kb/xuat-kho-vthh-su-dung/', // Xuất kho VTHH
  INTransfer: 'https://mimosahelp.misa.vn/kb/chuyen-kho-vat-tu-hang-hoa/', // Chuyển kho VTHH
  INAjustment: 'https://mimosahelp.misa.vn/kb/dieu-chinh-ton-kho/', // Điều chỉnh tồn kho
  CalcInOutward: 'https://mimosahelp.misa.vn/kb/tinh-gia-xuat-kho/', // Tính giá xuất kho
  SaleInvoice: 'https://mimosahelp.misa.vn/kb/quan-ly-danh-sach-hoa-don-dien-tu/', // Danh sách hóa đơn
  SASaleInvoiceDetail: 'https://mimosahelp.misa.vn/kb/lap-hoa-don-co-ket-noi-meinvoice/', // Lập hóa đơn điện tử
  ElectronicTicketDetail: 'https://mimosahelp.misa.vn/kb/lay-ve-dien-tu-tu-misa-meinvoice/', // Màn hủy hóa đơn
  CancelInvoice: 'https://mimosahelp.misa.vn/kb/huy-hoa-don-nd123/', // Hủy hóa đơn
  SaleInvoiceReplace: 'https://mimosahelp.misa.vn/kb/lap-hoa-don-thay-the-nd123/', // Lập hóa đơn thay thế
  ChooseAdjustSaleInvoice: 'https://mimosahelp.misa.vn/kb/lap-hoa-don-dieu-chinh-nd123/', // Lập hóa đơn tùy chỉnh
  StatisticalDayOff: 'https://mimosahelp.misa.vn/kb/tong-hop-ngay-nghi-lam-them/', // Tổng hợp ngày nghỉ/làm thêm
  OtherIncome: 'https://mimosahelp.misa.vn/kb/tong-hop-thu-nhap-khong-thuong-xuyen/',
  PAOtherOutcome: 'https://mimosahelp.misa.vn/kb/khau-tru-khong-thuong-xuyen/',
  PARetroSalaryIncrease: 'https://mimosahelp.misa.vn/kb/tinh-luong-truy-linh/#truy-linh-doi-voi-truong-hop-nang-luong',
  PARetroStandardSalaryIncrease:
    'https://mimosahelp.misa.vn/kb/tinh-luong-truy-linh/#tinh-luong-truy-linh-doi-voi-truong-hop-nang-muc-luong-co-so',
  Salary: 'https://mimosahelp.misa.vn/kb/tinh-luong-bao-hiem-thue-thu-nhap-ca-nhan/',
  PAPaySalaryGenData: 'https://mimosahelp.misa.vn/kb/tra-luong/',
  PAPayTax: 'https://mimosahelp.misa.vn/kb/tinh-va-nop-thue-tncn/',
  PUPayment: 'https://mimosahelp.misa.vn/kb/mua-hang-tra-tien-ngay/',
  PUInvoice: 'https://mimosahelp.misa.vn/kb/mua-hang-chua-thanh-toan/',
  PUVendor: 'https://mimosahelp.misa.vn/kb/tra-tien-nha-cung-cap/',
  CAReceiptSale: 'https://mimosahelp.misa.vn/kb/ban-hang-thu-tien-ngay/',
  SAInvoice: 'https://mimosahelp.misa.vn/kb/ban-hang-chua-thu-tien/',
  CAReceiptCustomer: 'https://mimosahelp.misa.vn/kb/thu-tien-khach-hang/',
  SAReturn: 'https://mimosahelp.misa.vn/kb/hang-ban-tra-lai/',
  GLVoucher: 'https://mimosahelp.misa.vn/kb/chung-tu-nghiep-vu-khac/',
  VoucherSummaryTable: 'https://mimosahelp.misa.vn/kb/lap-bang-tong-hop-chung-tu-cung-loai/',
  GLPostedVoucher: 'https://mimosahelp.misa.vn/kb/lap-chung-tu-ghi-so/',
  SummaryBook: 'https://mimosahelp.misa.vn/kb/so-cai/',
  ProvisionalTaxInCome: 'https://mimosahelp.misa.vn/kb/tam-tinh-thue-thu-nhap-doanh-nghiep/',
  FinalTaxInComeEnterprise: 'https://mimosahelp.misa.vn/kb/quyet-toan-thue-thu-nhap-doanh-nghiep/',
  BATransferDeposit: 'https://mimosahelp.misa.vn/kb/tien-chuyen-den/',
  BATransferWithdraw: 'https://mimosahelp.misa.vn/kb/tien-chuyen-di/',
  GLProfitLossTransfer: 'https://mimosahelp.misa.vn/kb/xac-dinh-ket-qua-hoat-dong/',
  EndYearTransfer: 'https://mimosahelp.misa.vn/kb/ket-chuyen-so-du-cuoi-nam/',
  NotPostedCloseBook: 'https://mimosahelp.misa.vn/kb/khoa-so-ke-toan/',
  CRERepList: 'https://mimosahelp.misa.vn/kb/tong-hop-bao-cao-tai-chinh/',
  CRERepSettleMent: 'https://mimosahelp.misa.vn/kb/tong-hop-bao-cao-quyet-toan/',
  CRERepExportList: 'https://mimosahelp.misa.vn/kb/xuat-khau-bao-cao-gui-kho-bac-nha-nuoc/',
  CRERepSubmit: 'https://mimosahelp.misa.vn/kb/xuat-khau-bao-cao-tai-chinh/',
  CRERepexportListTax: 'https://mimosahelp.misa.vn/kb/nop-bao-cao-cho-co-quan-thue/',
  BeginningYearTransfer: 'https://mimosahelp.misa.vn/kb/quyet-toan-so-du-dau-nam/',
  OPAccountBalance: 'https://mimosahelp.misa.vn/kb/khai-bao-so-du-ban-dau/',
  Dictionary: 'https://mimosahelp.misa.vn/kb/khai-bao-danh-muc/',
  AccountParallelRule: 'https://mimosahelp.misa.vn/kb/thiet-lap-quy-tac-hach-toan-dong-thoi/',
  ChoseFinanceReportSetting: 'https://mimosahelp.misa.vn/kb/thiet-lap-bao-cao-tai-chinh/',
  CustomSetting: 'https://mimosahelp.misa.vn/kb/thiet-lap-tuy-chon/',
  BUTransferFixedAsset: 'https://mimosahelp.misa.vn/kb/rut-du-toan-chuyen-khoan-mua-tscd/',
  CAPaymentFixedAsset: 'https://mimosahelp.misa.vn/kb/chi-mua-tai-san-co-dinh-bang-tm/',
  BAWitdDrawFixedAsset: 'https://mimosahelp.misa.vn/kb/chi-mua-tai-san-co-dinh/',
  VoucherIncrement: '',
  VoucherDecrement: '',
  VoucherAdjustment: 'https://mimosahelp.misa.vn/kb/danh-gia-lai-tscd/',
  FATransfer: 'https://mimosahelp.misa.vn/kb/dieu-chuyen-tscd/',
  VoucherDepreciate: 'https://mimosahelp.misa.vn/kb/trich-khau-hao-tai-san-co-dinh/',
  VoucherDepreciation: 'https://mimosahelp.misa.vn/kb/tinh-hao-mon-tai-san-co-dinh/',
  SUIncrement: 'https://mimosahelp.misa.vn/kb/ghi-tang-cong-cu-dung-cu/',
  SUTransfer: 'https://mimosahelp.misa.vn/kb/dieu-chuyen-cong-cu-dung-cu/',
  SUBook: 'https://mimosahelp.misa.vn/kb/so-cong-cu-dung-cu/',
  SUDecrement: 'https://mimosahelp.misa.vn/kb/ghi-giam-cong-cu-dung-cu/',
  Help: 'https://mimosahelp.misa.vn',
  //Đăng nhập
  Login: 'https://mimosahelp.misa.vn/kb/dang-nhap/',
  //Tạo DLKT
  CreateDatabase: 'htthttps://mimosahelp.misa.vn/kb/quan-ly-du-lieu/',
  //Chuyển đổi dữ liệu
  ConvertDatabase: 'https://helpmimosaonline.misa.vn/kb/chuyen-doi-du-lieu-tu-misa-mimosa-2025-len-misa-mimosa-online/',
  InitDefaultAmount: 'https://mimosahelp.misa.vn/kb/khai-bao-so-du-ban-dau/',
  //Hệ thống tài khoản
  SystemAccountList: 'https://mimosahelp.misa.vn/kb/he-thong-tai-khoan/',
  //Tài khoản kết chuyển
  AccountTransfer: 'https://mimosahelp.misa.vn/kb/tai-khoan-ket-chuyen/',
  //Tài khoản ngầm định
  DefaultAccountList: 'https://mimosahelp.misa.vn/kb/tai-khoan-ngam-dinh/',
  //Định khoản tự động
  AutoBusiness: 'https://mimosahelp.misa.vn/kb/dinh-khoan-tu-dong/',
  //Tính chất nguồn kinh phí
  BudgetSourceProperty: 'https://mimosahelp.misa.vn/kb/tinh-chat-nguon-kinh-phi/',
  //Nguồn kinh phí
  BudgetSource: 'https://mimosahelp.misa.vn/kb/nguon-kinh-phi/',
  //Mã dự phòng
  BudgetProvide: 'https://mimosahelp.misa.vn/kb/ma-du-phong/',
  //Chương
  BudgetChapter: 'https://mimosahelp.misa.vn/kb/chuong/',
  //Loại khoản
  BudgetKindItem: 'https://mimosahelp.misa.vn/kb/loai-khoan/',
  //Nhóm mục chi
  BudgetGroupItem: 'https://mimosahelp.misa.vn/kb/nhom-muc-chi/',
  //Mục/Tiểu mục
  BudgetItem: 'https://mimosahelp.misa.vn/kb/muc-tieu-muc/',
  //Phòng/ban
  Department: 'https://mimosahelp.misa.vn/kb/phong-ban/',
  //Loại cán bộ
  EmployeeType: 'https://mimosahelp.misa.vn/kb/loai-can-bo/',
  //Khoản lương
  PayrollItem: 'https://mimosahelp.misa.vn/kb/khoan-luong/',
  //Ngạch lương
  SalaryScale: 'https://mimosahelp.misa.vn/kb/ngach-luong/',
  //Quy định lương, thuế, bảo hiểm
  PAOption: 'https://mimosahelp.misa.vn/kb/quy-dinh-luong-thue-bao-hiem/',
  //Khách hàng/Nhà cung cấp
  CustomerVender: 'https://mimosahelp.misa.vn/kb/khach-hang-nha-cung-cap/',
  //Khách hàng/Nhà cung cấp
  AccountingObject: 'https://mimosahelp.misa.vn/kb/loai-khach-hang-nha-cung-cap/',
  //Loại tài khoản tiềm gửi kho bạc
  BankInfoCategory: 'https://mimosahelp.misa.vn/kb/loai-tai-khoan-tien-gui-kho-bac/',
  //Tài khoản ngân hàng, kho bạc
  BankInfo: 'https://mimosahelp.misa.vn/kb/tai-khoan-ngan-hang-kho-bac/',
  //Cán bộ
  Employee: 'https://mimosahelp.misa.vn/kb/can-bo/',
  //Kho
  Stock: 'https://mimosahelp.misa.vn/kb/kho/',
  //Vật tư hàng hóa
  InventoryItem: 'https://mimosahelp.misa.vn/kb/vat-tu-hang-hoa/',
  //Loại vật tư hàng hóa
  InventoryCategory: 'https://mimosahelp.misa.vn/kb/loai-vat-tu-hang-hoa/',
  //Công cụ dụng cụ
  ToolList: 'https://mimosahelp.misa.vn/kb/cong-cu-dung-cu/',
  //Loại công cụ dụng cụ
  ToolType: 'https://mimosahelp.misa.vn/kb/loai-cong-cu-dung-cu/',
  //Loại tài sản cố định
  FixAssetType: 'https://mimosahelp.misa.vn/kb/loai-tai-san-co-dinh/',
  //Tài sản cố định
  FixAsset: 'https://mimosahelp.misa.vn/kb/tai-san-co-dinh/',
  //Loại quỹ
  FundType: 'https://mimosahelp.misa.vn/kb/loai-quy/',
  //CTMT, Dự án
  Project: 'https://mimosahelp.misa.vn/kb/ctmt-du-an/',
  //Phí, lệ phí
  Fee: 'https://mimosahelp.misa.vn/kb/phi-le-phi/',
  //Nhóm hàng hóa dịch vụ mua vào
  PurchasePurpose: 'https://mimosahelp.misa.vn/kb/nhom-hang-hoa-dich-vu-mua-vao/',
  //Mẫu số hóa đơn
  InvoiceFormNumber: 'https://mimosahelp.misa.vn/kb/mau-so-hoa-don/',
  //Loại chứng từ
  VoucherType: 'https://mimosahelp.misa.vn/kb/loai-chung-tu/',
  //Nhiệm vụ
  Task: 'https://mimosahelp.misa.vn/kb/nhiem-vu/',
  //Hoạt động
  Activity: 'https://mimosahelp.misa.vn/kb/hoat-dong/',
  //Mã thống kê
  Statistics: 'https://mimosahelp.misa.vn/kb/ma-thong-ke/',
  //Cơ cấu vốn
  FundStructure: 'https://mimosahelp.misa.vn/kb/co-cau-von/',
  //Đề tài
  Topic: 'https://mimosahelp.misa.vn/kb/de-tai/',
  //Loại tiền
  Currency: 'https://mimosahelp.misa.vn/kb/loai-tien/',
  //Hợp đồng
  Contract: 'https://mimosahelp.misa.vn/kb/hop-dong/',
  //Nhập dự toán
  BUPlanImport: 'https://mimosahelp.misa.vn/kb/nhap-du-toan/',
  //Nhận dự toán
  BUPlanReceipt: 'https://mimosahelp.misa.vn/kb/nhan-du-toan/',
  //Điều chỉnh dự toán
  BUPlanAdjustment: 'https://mimosahelp.misa.vn/kb/dieu-chinh-du-toan/',
  //Hủy dự toán
  BUPlanCancle: 'https://mimosahelp.misa.vn/kb/huy-du-toan/',
  //Nhập cam kết chi ban đầu
  BUOpeningCommitment: 'https://mimosahelp.misa.vn/kb/nhap-cam-ket-chi-ban-dau/',
  //Đề nghị cam kết chi
  BUCommitmentRequest: 'https://mimosahelp.misa.vn/kb/de-nghi-cam-ket-chi/',
  //Điều chỉnh cam kết chi
  BUCommitmentAdjustment: 'https://mimosahelp.misa.vn/kb/dieu-chinh-cam-ket-chi/',
  //Rút dự toán tiền mặt
  CAPlanWithDraw: 'https://mimosahelp.misa.vn/kb/quy-trinh-rut-du-toan-tam-ung-da-cap-bang-tien-mat/',
  //Rút dự toán tiền gửi
  BUPlanWithDraw: 'https://mimosahelp.misa.vn/kb/quy-trinh-rut-du-toan-tam-ung-da-cap-bang-tien-mat-tien-gui/',
  //Rút dự toán chuyển khoản kho bạc
  BUPlanWithDrawTransfer:
    'https://mimosahelp.misa.vn/kb/quy-trinh-rut-du-toan-tam-ung-da-cap-bang-chuyen-khoan-kho-bac/',
  //Rút dự toán tiền mặt
  CAPlanWithDrawNotPlaned:
    'https://mimosahelp.misa.vn/kb/quy-trinh-rut-du-toan-tam-ung-chua-cap-bang-tien-mat-tien-gui/',
  //Rút dự toán tiền gửi
  BUPlanWithDrawNotPlaned:
    'https://mimosahelp.misa.vn/kb/quy-trinh-rut-du-toan-tam-ung-chua-cap-bang-tien-mat-tien-gui/',
  //Rút dự toán chuyển khoản kho bạc
  BUPlanWithDrawTransferNotPlaned:
    'https://mimosahelp.misa.vn/kb/quy-trinh-rut-du-toan-tam-ung-chua-cap-bang-chuyen-khoan-kho-bac/',
  //Rút dự toán tiền mặt
  CAPlanWithDrawRealExpense: 'https://mimosahelp.misa.vn/kb/quy-trinh-rut-du-toan-thuc-chi-bang-tien-mat-tien-gui/',
  //Rút dự toán tiền gửi
  BUPlanWithDrawRealExpense: 'https://mimosahelp.misa.vn/kb/quy-trinh-rut-du-toan-thuc-chi-bang-tien-mat-tien-gui/',
  //Rút dự toán chuyển khoản kho bạc
  BUPlanWithDrawTransferRealExpense:
    'https://mimosahelp.misa.vn/kb/quy-trinh-rut-du-toan-thuc-chi-bang-chuyen-khoan-kho-bac/',
  //Rút dự toán chuyển khoản lương, bảo hiểm
  BUPlanWithDrawTransferPAOption: 'https://mimosahelp.misa.vn/kb/chuyen-khoan-kho-bac-tra-luong/',
  //Điều chỉnh kinh phí
  BUPlanWDAdjustment: 'https://mimosahelp.misa.vn/kb/dieu-chinh-kinh-phi/',
  //Dự toán giữ lại
  BUBudgetReserve: 'https://mimosahelp.misa.vn/kb/du-toan-giu-lai/',
  //Bảng kê chứng từ thanh toán đã cấp dự toán
  BUVoucherList: 'https://mimosahelp.misa.vn/kb/lap-bang-ke-chung-tu-thanh-toan-va-thanh-toan-tam-ung-da-cap-du-toan/',
  //Bảng kê chứng từ thanh toán chưa cấp dự toán
  BUVoucherListNotPlaned: 'https://mimosahelp.misa.vn/kb/lap-bang-ke-va-thanh-toan-tam-ung-chua-cap-du-toan/',
  //Bảng kê chứng từ ghi thu ghi chi
  BUVoucherListReceiptExpense: 'https://mimosahelp.misa.vn/kb/lap-bang-ke-chung-tu-ghi-thu-ghi-chi/',
  /** Kho bạc */
  Treasury: 'https://mimosahelp.misa.vn/kb/ke-toan-kho-bac/',

  // Đối chiếu số dư tiền mặt với biên bản kiểm kê
  CashBalanceReconciliation: 'https://mimosahelp.misa.vn/kb/doi-chieu-so-du-tien-mat-voi-bien-ban-kiem-ke/',

  // Đối chiếu số dư tài khoản ngân hàng với số phụ
  ReconcileBankAccountBalance: 'https://mimosahelp.misa.vn/kb/doi-chieu-so-du-tai-khoan-ngan-hang-voi-so-phu/',
  // Đối chiếu tài sản cố định với biên bản kiểm kê
  ReconciliationFixedAsset: 'https://mimosahelp.misa.vn/kb/doi-chieu-tai-san-co-dinh-voi-bien-ban-kiem-ke/',
  // Đối chiếu số dư tiền mặt với biên bản kiểm kê
  ReconciliationMaterials: 'https://mimosahelp.misa.vn/kb/doi-chieu-vat-tu-hang-hoa-ton-kho/',
  // báo cáo tài chính
  ReportFinancial: 'https://mimosahelp.misa.vn/kb/tong-hop-bao-cao-tai-chinh/',
  // Lập báo cáo quyet toan
  ReportSettIlement: 'https://mimosahelp.misa.vn/kb/tong-hop-bao-cao-quyet-toan/',
  //Hướng dẫn in báo cáo
  InstructionPrintReport: 'https://mimosahelp.misa.vn/kb/huong-dan-in-bao-cao/',
  // Xuất khẩu báo cáo tài chính
  ExportFinancial: 'https://mimosahelp.misa.vn/kb/buoc-4-xuat-khau-bao-cao-tai-chinh/',
  // Lập phiếu thu tiền mặt từ MISA EMIS
  CAReceiptMisaEmis: 'https://mimosahelp.misa.vn/kb/lap-phieu-thu-tien-mat-tu-misa-emis/',
  // Lập phiếu thu tiền gửi từ MISA EMIS
  BaDepositMisaEmis: 'https://mimosahelp.misa.vn/kb/lap-phieu-thu-tien-gui-tu-misa-emis/',
  // Lấy biên lai từ meInvoice
  BaDepositMisaEmis: 'https://mimosahelp.misa.vn/kb/lay-bien-lai-tu-meinvoice/',
  // Nhập CCDC ban đầu
  OpeningSupplyEntry: 'https://mimosahelp.misa.vn/kb/nhap-ccdc-ban-dau/',
  // Sắp xếp lại số chứng từ
  SortVoucher: 'https://mimosahelp.misa.vn/kb/sap-xep-lai-so-chung-tu/',
  // Khóa sổ kỳ kế toán
  LockLedgerVoucher: 'https://mimosahelp.misa.vn/kb/khoa-so-ky-ke-toan/',
  // Bỏ khóa sổ kỳ kế toán
  UnlockLedgerVoucher: 'https://mimosahelp.misa.vn/kb/bo-khoa-so-ky-ke-toan/',
  // Ghi sổ/Bỏ ghi sổ theo lô
  PostVoucher: 'https://mimosahelp.misa.vn/kb/ghi-so-bo-ghi-so-theo-lo/',
  // Tùy chọn in
  SettingPrint: 'https://mimosahelp.misa.vn/kb/tuy-chon-in/',
  // In theo lô
  ChooseVoucherReport: 'https://mimosahelp.misa.vn/kb/in-theo-lo-nhieu-chung-tu/',
  // Bảo trì dữ liệu
  DataMaintenance: 'https://mimosahelp.misa.vn/kb/bao-tri-du-lieu/',
  // Sao lưu và phục hồi dữ liệu
  Backup: 'https://mimosahelp.misa.vn/kb/sao-luu-du-lieu/',
  // Quản lý người dùng
  ManagementUser: 'https://mimosahelp.misa.vn/kb/quan-ly-nguoi-dung/',
  // Bàn giao tài khoản
  AccountHandOver: 'https://mimosahelp.misa.vn/kb/quan-ly-nguoi-dung/#ban-giao-tai-khoan',
  // Vai trò quyền hạn
  SystemUserRole: 'https://mimosahelp.misa.vn/kb/vai-tro-va-quyen-han/',
  // Phục hồi chứng từ đã xóa
  RestoreVoucher: 'https://mimosahelp.misa.vn/kb/phuc-hoi-chung-tu-da-xoa/',

  // Ghi sổ không thành công
  ErrorPosted:
    'https://mimosahelp.misa.vn/kb/truong-hop-khong-tim-thay-cot-tren-chung-tu-dan-den-ghi-so-khong-thanh-cong-thi-phai-lam-nhu-the-nao/',
  // Lấy số dư đầu năm
  OPAccountEntryPrevYear: 'https://mimosahelp.misa.vn/kb/lay-so-du-dau-nam/',
  //Thiết kế mẫu chứng từ
  ReportMerge: 'https://mimosahelp.misa.vn/kb/thiet-ke-mau-chung-tu/',
  // Cập nhật thông tư 23/2023/TT-BTC
  ConvertTT23: 'https://mimosahelp.misa.vn/kb/cap-nhat-thong-tu-23-2023-tt-btc/',
  // Hồ sơ giao dịch
  DVCFile:
    'https://mimosahelp.misa.vn/kb/kho-bac-dien-tu/#a-cac-buoc-lap-va-gui-ho-so-giao-dich-truc-tiep-len-dvc-kbnn',
  // Quản lý hồ sơ đối chiếu số dư
  DCSDFile:
    'https://mimosahelp.misa.vn/kb/kho-bac-dien-tu/#b-cac-buoc-lap-va-gui-bao-cao-doi-chieu-kho-bac-truc-tiep-len-dvc-kbnn',
  // Kết xuất dữ liệu – Kết nối KBNN
  DVCExportSubmit: 'https://mimosahelp.misa.vn/kb/ket-xuat-du-lieu-de-ket-noi-den-kho-bac-nha-nuoc/',
  // Lập chứng từ thu phí, lệ phí cho các biên lai đã lập
  Receipt: 'https://mimosahelp.misa.vn/kb/lap-chung-tu-thu-phi-le-phi-cho-cac-bien-lai-da-lap/',
  // Tùy chỉnh giao diện
  SettingLayout: 'https://mimosahelp.misa.vn/kb/tuy-chinh-giao-dien/',
  // Thông tin đơn vị
  CompanyInfo: 'https://mimosahelp.misa.vn/kb/thong-tin-don-vi/',
  // Lấy biên lai từ meInvoice
  ReceiptMeInvoice: 'https://mimosahelp.misa.vn/kb/lay-bien-lai-tu-meinvoice/',
  // Quản lý dữ liệu
  DataManager: 'https://mimosahelp.misa.vn/kb/quan-ly-du-lieu/',
  // Xuất khẩu dữ liệu
  SendAccountingDataHD: 'https://mimosahelp.misa.vn/kb/xuat-khau-du-lieu/',
  // Thiết lập chữ ký số
  SettingEsign: 'https://mimosahelp.misa.vn/kb/thiet-lap-chu-ky-so/',
  // Thiết lập tùy chọn
  SetUpOption: 'https://mimosahelp.misa.vn/kb/thiet-lap-tuy-chon/',
  // Thông báo trả lương đến cán bộ
  NotifySalaryPayment:
    'https://mimosahelp.misa.vn/kb/bo-sung-chuc-nang-gui-thong-bao-tra-luong-den-toan-bo-cbnv-trong-don-vi/',
  // gửi email nhắc nợ
  ReminderDebtEmail: 'https://mimosahelp.misa.vn/kb/gui-email-nhac-no/',
  // Thiết lập cấu hình gửi email nhắc nợ
  EmailConfig: 'https://mimosahelp.misa.vn/kb/thiet-lap-cau-hinh-gui-email/',
  // Màn hình tính năng mới (link iframe)
  NewsFeature: 'https://mimosaonline.misa.vn/tinh-nang-moi-mimosaonline/?custom=hide',

  //Chuyển chế độ kế toán
  ConversionOfAccountingSystem: 'https://helpmimosaonline.misa.vn/kb/chuyen-che-do-ke-toan/',

  //Trang chủ help TT24
  HelpTT24: 'https://helpmimosaonline.misa.vn/',
};
